<template>
  <div class="alternative-scrolling  container-image-inline-scroll">
    <div class="container-img" v-if="!mobile" :class="align">
      <div class="container-image-inline-scroll__image-full" :class="align">
        <img :src="url" :class="align" />
        <div :class="align" class="author-photo__longer">{{ credit }}</div>
      </div>
      <div class="legend" :class="desc_align" v-if="legend">
        <div v-html="legend"></div>
      </div>
    </div>
    <div class="container-img" v-if="mobile">
      <img class="d-md-block d-none container-image-inline-scroll__image-full" :src="url" :class="align" />
      <img class="d-md-none d-block container-image-inline-scroll__image-full" :src="urlMobile" :class="align" />
      <div class="legend" :class="desc_align" v-if="legend">
        <div v-html="legend"></div>
      </div>
    </div>
    
    <div :class="align" class="author-photo">{{ credit }}</div>
  </div>
</template>

<style lang="scss">

  .container-image-inline-scroll {
    position: relative;
    width: 100vw;
    left: calc((100vw - 98%) / 2 * -1);
    margin: 35px 0;

    @media (max-width: 575.98px) {
      left: calc(((100vw - 100%) / 2) * -1);
    }

    .container-img {
      position: relative;
      min-height: 250vh;

      @media (max-width: 575.98px) {
        min-height: 200vh;
      }
    }

    .author-photo__longer {
      display: none;
      font: 300 15px 'Lato', sans-serif;
      width: 100%;
      position: relative;
      bottom: 0;
      right: 0;
      color: #747474;
      pointer-events: none;
      text-align: right;
      padding: 10px 15px;

      &.longer {
        display: block;
      }
    }

    &__image-full {
      position: sticky;
      top: 0;
      display: block;

      @media (max-width: 575.98px) {
        top: 25vh;
      }

      img {
        display: block;
        width: 100%;
        min-height: 100vh;
        object-fit: cover;
        object-position: center top;
        
        @media (max-width: 575.98px) {
          height: 60vh;
          min-height: 60vh;
        }
        
        &.r-center {
          object-position: 72% top !important;
        }
        
        &.longer {
          @media (max-width: 575.98px) {
            min-height: 50vh;
          }
        }

        &.right {
          object-position: 85% top !important;
        }
        
        &.left {
          object-position: 30% top !important;
        }
        
        &.center {
          object-position: 56% top !important;
        }

        &.center-p {
          object-position: 59% top !important;
        }
      }
    }

    .author-photo {
      font: 300 15px 'Lato', sans-serif;
      width: 100%;
      position: relative;
      bottom: 0;
      right: 0;
      color: #747474;
      pointer-events: none;
      text-align: right;
      padding: 10px 15px;

      &.longer {
        display: none;
      }
    }

    .legend {
      position: relative;
      margin: 0 auto;
      padding: 10px;
      font-size: 20px;
      font-weight: 300;
      font-family: 'Roboto Slab';
      color: #333;
      background: #ffffff9e;
      width: 100%;
      max-width: 560px;
      text-align: center;
      box-shadow: 0px 0px 2px 2px #33333314;

      &.left {
        margin: 0 auto 0 7% !important;
        max-width: 520px;
      }

      @media (max-width: 575.98px) {
        &.left {
          margin: 0 auto 0 auto !important;
          max-width: 480px;
        }
      }
    }


    &.alternative-scrolling {
        .left {
          max-width: 340px;
          font-family: 'Roboto';
          font-weight: 300;
          text-align: left;
          color: #000;
          box-shadow: none;
          font-size: 27px;
          text-shadow: 1px 1px 3px #fff;

          @media (max-width: 575.98px) {
            font-size: 27px;
          }
        }
      }
  }
</style>

<script>
  export default {
    name: 'ImageInlineScroll',
    props: {
      src: {
        type: String,
        default: ``
      }
    },
    computed: {
      url() {
        const path = this.src.split('|')
        if(path[0])
          return path[0]
        return this.src
      },
      urlMobile() {
        const path = this.src.split('|')
        if(path[0])
          return (path[0]).replace(".png", "_movil.png")
        return this.src
      },
      legend() {
        const path = this.src.split('|')
        if(path[1])
          return path[1]
        return ``
      },
      align() {
        const path = this.src.split('|')
        if(path[2])
          return path[2]
        return ``
      },
      credit() {
        const path = this.src.split('|')
        if(path[3])
          return path[3]
        return `Créditos Univision`
      },
      desc_align() {
        const path = this.src.split('|')
        if(path[4])
          return path[4]
        return ``
      },
      mobile() {
        const path = this.src.split('|')
        if(path[5])
          return true
        return false
      }
    }
  }
</script>